// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderStyles } from "@awc/Overrides/Widgets/Basic/QuickOrder";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

quickOrderStyles.titleGridItem = { width: [12, 6, 6, 6, 6] };

quickOrderStyles.linksGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
        align-items: baseline;
        row-gap: 4px;
        &&& {
            max-width: max-content;
            margin-left: auto;
            ${xScreen("lte", "sm")} {
                max-width: 100%;
                flex-basis: 100%;
            }
        }
    `,
};

quickOrderStyles.container = {
    gap: 0,
    css: css`
        margin-bottom: 8px;
    `,
};

quickOrderStyles.titleText = {
    variant: "h3",
    forwardAs: "h2",
};

quickOrderStyles.productSelector = {};

quickOrderStyles.styledBox = {
    container: {
        css: css`
            margin-bottom: 28px;
        `,
    },
};

quickOrderStyles.orderMultipleItemsLink = {};
